import { HTTPMethod, IRequest } from "../Inetwork";
import {
  ICSSMangement,
  IUserProfile,
  IUserProfileRequest,
  IAllCSSQuestion,
  IQuestion,
} from "@/global/interfaces/httprequestinterface";

/* tslint:disable */
export class AuthenticationRequest implements IRequest {
  public path: string;
  public method = HTTPMethod.POST;
  public data: IUserProfileRequest;

  constructor(requestData: IUserProfile) {
    this.path = "/customer/login";

    this.data = {
      evaluator: requestData.id,
      code: requestData.password,
    };
  }
}

export class GetUserInfoRequest implements IRequest {
  public path: string;
  public method = HTTPMethod.GET;

  constructor() {
    this.path = "/customer/info";
  }
}

export class ResendCodeRequest implements IRequest {
  public path: string;
  public method = HTTPMethod.POST;
  public data: any;

  constructor(cssId: Number) {
    this.path = "/customer/resend";
    this.data = { cssId: cssId};
  }
}

export class GetCSSQuestionCategory implements IRequest {
  public path: string;
  public method = HTTPMethod.GET;
  public data: IAllCSSQuestion;

  constructor(id: string) {
    this.path = "/customer/css/scopes?cssId=" + id;
  }
}

export class GetCSSQuestion implements IRequest {
  public path: string;
  public method = HTTPMethod.GET;
  public data: IAllCSSQuestion;

  constructor(id: string) {
    this.path = "/customer/css/question?cssId=" + id;
  }
}

export class UpdateCSSQuestion implements IRequest {
  public path: string;
  public method = HTTPMethod.PUT;
  public data: any;

  constructor(questionData: IQuestion) {
    this.path = "/customer/css";
    const data = {
      css_id: questionData.cssId,
      question: questionData.question,
    };
    this.data = data;
  }
}

export class FeedbackRequest implements IRequest {
  public path: string;
  public method = HTTPMethod.GET;
  public data: ICSSMangement;

  constructor(id: string) {
    this.path = "customer/feedback/" + id;
  }
}
